export enum PropertyType {
  PARENT_TABLE = 'Parent Table',
  FPK = 'Functional Primary Key',
  WORKFLOW_ACTOR = 'Workflow Actor',
  LOOKUP_FIELDS = 'Lookup Fields',
  COMPOSITE_DATATYPE = 'Composite Data Type',
  LOOKUP = 'Lookup',
  IMPORT = 'Import',
  EXPORT = 'Export',
  MANDATORY_INPUT_FILTERS = 'Madatory Input Filters',
  EXPORT_ROLES = 'Export Roles',
  EXPORT_FILTER = 'Export Filter',
  IMPORT_ROLES = 'Import Roles',
  WORKFLOW_ACTION = 'Workflow Action',
  LOOKUP_OPTIONAL_FILTERS = ' Lookup Optional Filters',
  LOOKUP_DISPLAY_FIELD = 'Lookup Display Field',
  LOOKUP_TO = 'Lookup To',
  WORKFLOW_ACTION_REF = 'WORKFLOW_ACTION',
  EXPORT_FIELDS = 'Export Fields',
  EXPORT_FILTERS = 'Export Filters',
  LOOKUP_MANDATORY_FILTERS = 'Lookup mandatory filters',
  QUERY_BUILDER = 'Query builder',
  ROLE_FIELD = 'Role field',
  TABLE_OF_SERVICE = 'Table of service',
  ALLOWED_ROLES_FOR_SERVICES = 'Allowed roles for services',
  IMPORT_FIELDS = 'Import fields',
  OPTIONAL_FILTER = 'Optional filter',
  INDEX = 'Index',
  FOREIGN_KEY = 'Foreign key',
  FOREIGN_KEY_PARENT_INDEX = 'Foreign key parent index',
  WORKFLOW_ACTOR_ENABLED_FIELDS = 'Workflow actor enabled fields',
  WORKFLOW_ACTOR_HIDDEN_FIELDS = 'Workflow actor hidden fields',
  WORKFLOW_ACTOR_SHOW_FIELDS = 'Workflow actor show fields',
  WORKFLOW_ACTOR_DISABLED_FIELDS = 'Workflow actor disabled fields',
  LOOKUPTO_FILTER_INPUT_MAPPING_FIELDS = 'Lookupto filter input mapping fields',
  LOOKUP_OUTPUT_MAPPING_FIELDS = 'Lookup output mapping fields',
  WORKFLOW_ACTION_NEXT_STATUS = 'Workflow action next status',
  WORKFLOW_ACTION_NEXT_ACTOR = 'Workflow action next actor',
  WORKFLOW_ACTOR_HIDDEN_ACTION = 'Workflow actor hidden action',
  WORKFLOW_ACTOR_SHOW_ACTION = 'Workflow actor show action',
  WORKFLOW_ACTOR_DISABLED_ACTION = 'Workflow actor disabled action',
  WORKFLOW_ACTOR_ENABLED_ACTION = 'Workflow actor enabled action',
  WORKFLOW_ACTION_MANDATORY_FIELDS = 'Workflow action mandatory fields',
  WORKFLOW_HISTORY_BUTTON = 'Workflow history button',
  WORKFLOW_ACTION_BUTTON = 'Workflow action button',
  WORKFLOW_ACTION_SERVICE = 'Workflow action service',
  WORKFLOW_TABLE = 'Workflow table',
  WORKFLOW_FIELDS_VALUES = 'Workflow fields values',
  WORKFLOW_MAIL_TO = 'Workflow mail to',
  WORKFLOW_MAIL_CC = 'Workflow mail CC',
  NAVIGATION_DETAIL_PAGE = 'Detail Page',
  NAVIGATION_PAGE = 'Page',
  DEFAULT_SORT_ON = 'Default sort on',
  GROUP_ON_COLUMN = 'Group on column',
  GROUPS_ON_COLUMN = 'Groups on column',
  TABLE_SEARCH = 'Table search',
  QUICK_FILTERS = 'Quick filters',
  CAPTION_BAR = 'Caption bar',
  TABLE = 'Table',
  FORM = 'Form',
  BQ_DATASET_VALUE = 'Bq dataset value',
  MANDATORY_CONDITIONAL = 'Mandatory conditional',
  EDIT_CONDITIONAL = 'Edit conditional',
  VIEW_CONDITIONAL = 'View conditional',
  BUTTON_ENABLED_CONDITIONAL = 'Button enabled conditional',
  BUTTON_VISIBILITY_CONDITIONAL = 'Button visibility conditional',
  SERVICE = 'Service',
  TABLE_PAGE = 'Table page',
  QUERY_PAGE = 'Table page',
  QUERY_VIEW_MULTIPLE_DETAIL_PAGE = 'Table page',
  WORKFLOW_ACTOR_STEP = 'Workflow actor step',
  WORKFLOW_ACTION_STEP = 'Workflow action step',
  WORKFLOW_FIELD = 'Workflow field',
  WORKFLOW_ACTOR_STEP_FROM_STATUS = 'Workflow actor step from status',
  WORKFLOW_ACTOR_STEP_FROM_ACTOR = 'Workflow actor step from actor',
  WORKFLOW_MAIL = 'Workflow mail',
  WORKFLOW_SERVICE = 'Workflow service',
  EXPORT_MAIL = 'Export mail',
  IMPORT_MAIL = 'Import mail',
  EXPORT_MAIL_TO = 'Export mail to',
  IMPORT_MAIL_CC = 'Import mail CC',
  EXPORT_MAIL_CC = 'Export mail CC',
  IMPORT_MAIL_TO = 'Import mail to',
  UNIQUE_IDENTIFIER = 'Unique identifier',
  DATA_POPULATION_STRATEGY = 'Data population strategy',
  DATA_POPULATION_STRATEGY_FOREIGN_KEY = 'Data population strategy foreign key',
  DATA_POPULATION_STRATEGY_FIELD = 'Data population strategy field',
  ACCESS_CONTROL = 'Access Control',
  ALIGN_COLUMNS = 'Align columns',
  FORMULA_BUILDER = 'Formula builder',
  RUNTIME_STATUS_FIELD = 'Runtime Integration - Configure Fields - Runtime Workflow Status Field',
  DEFAULT_FILTERING_CRITERIA = 'Default Filtering Criteria',
  PARAMETER_MAPPING_QUERY_VIEW = 'Parameter Mapping',
}

export enum ComponentType {
  DATA_MODEL = 'Data Model',
  PAGES = 'Pages',
  WORKFLOW = 'Workflow',
  ROLES = 'Roles',
  CUSTOM_COMPONENT = 'Custom Component',
  THEMES = 'Themes',
  APP_SETTINGS = 'App Settings',
  SERVICE = 'Service',
  QUERY_BUILDER = 'Query Builder',
  TEMPLATE = 'Template'
}

export enum modelType {
  PAGE = 'PAGE',
  FIELD = 'FIELD',
  TABLE = 'TABLE',
  CUSTOM_COMPONENT = 'CUSTOM_COMPONENT',
  SERVICE = 'SERVICE',
  QUERY_BUILDER = 'QUERY_BUILDER',
  ROLE = 'ROLE',
  FOREIGN_KEY = 'FOREIGN_KEY',
  PAGE_VARIABLE = 'PAGE_VARIABLE',
  TECHNOLOGY_CHOICES = 'TECHNOLOGY_CHOICES',
  WORKFLOW = 'WORKFLOW',
  TABLE_ACL_CUSTOM_ACTION = 'TABLE_ACL_CUSTOM_ACTION',
  TABLE_ACL = 'TABLE_ACL',
  ACL_CUSTOM_ACTION = 'ACL_CUSTOM_ACTION',
  WORKFLOW_ACTION_REF = 'WORKFLOW_ACTION',
  FIELD_VALUE = 'FIELD_VALUE',
  GIT = 'GIT',
  LOOKUP_DEFINITION = 'LOOKUP_DEFINITION',
  APIGROUP = 'APIGROUP',
  LOOKUP_TEMPLATE = 'LOOKUP_TEMPLATE',
  MANDATORY_INPUT_FILTERS_DEFINITION = 'MANDATORY_INPUT_FILTERS_DEFINITION',
  UNIQUE_FOR_LOOKUP = 'Unique Fields',
  OPTIONAL_FILTER_FIELDS_DEFINITION = 'OPTIONAL_FILTER_FIELDS_DEFINITION',
  SKELETON_FILE = 'SKELETON_FILE',
  APIINFO = 'APIINFO',
  QUERY_STRING = 'QUERY_STRING',
  INDEX = 'INDEX',
  PROVIDER = 'PROVIDER'
}

export enum propertyName {
  NAVIGATION_DETAIL_PAGE = 'NAVIGATION_DETAIL_PAGE',
  NAVIGATION_PAGE = 'NAVIGATION_PAGE',
  DEFAULT_SORT_ON = 'DEFAULT_SORT_ON',
  GROUPS_ON_COLUMN = 'GROUPS_ON_COLUMN',
  GROUP_ON_COLUMN = 'GROUP_ON_COLUMN',
  TABLE_SEARCH = 'TABLE_SEARCH',
  QUICK_FILTERS = 'QUICK_FILTERS',
  CAPTION_BAR = 'CAPTION_BAR',
  TABLE = 'TABLE',
  FORM = 'FORM',
  SERVICE = 'SERVICE',
  ALIGN_COLUMNS = 'ALIGN_COLUMNS',
  ACCESS_CONTROL = 'ACCESS_CONTROL',
  BUTTON_ENABLED_CONDITIONAL = 'BUTTON_ENABLED_CONDITIONAL',
  BUTTON_VISIBILITY_CONDITIONAL = 'BUTTON_VISIBILITY_CONDITIONAL',
  MANDATORY_CONDITIONAL = 'MANDATORY_CONDITIONAL',
  DEFAULT_FILTER_PAGE_VARIABLE = 'DEFAULT_FILTER_PAGE_VARIABLE',
  EDIT_CONDITIONAL = 'EDIT_CONDITIONAL',
  VIEW_CONDITIONAL = 'VIEW_CONDITIONAL',
  FORMULA_BUILDER = 'FORMULA_BUILDER',
  PAGE_FIELDS = 'PAGE_FIELDS',
  CHILD_PAGE_TABLE = 'CHILD_PAGE_TABLE',
  CHILD_PAGE = 'CHILD_PAGE',
  QUERY_VIEW = 'QUERY_VIEW',
  PAGE_ACTION = 'PAGE_ACTION',
  DATABASE = 'DATABASE',
  LOOKUP_TO_FOREIGN_KEY = 'LOOKUPTO_FOREIGNKEY',
  LOOKUP_DEFINITION = 'LOOKUP_DEFINITION',
  LOOKUP_TO_QUERY_VIEW = 'LOOKUP_TO_QUERYVIEW',
  APIGROUP_SERVICE_BUTTON = 'APIGROUP_SERVICE_BUTTON',
  DETAIL_PAGE_MAPPING = 'DETAIL_PAGE_MAPPING',
  DETAIL_PAGE_MAPPING_SOURCE_FIELD = 'DETAIL_PAGE_MAPPING_SOURCE_FIELD',
  DETAIL_PAGE_MAPPING_TARGET_FIELD = 'DETAIL_PAGE_MAPPING_TARGET_FIELD',
  QUERY_VIEW_MAPPING = 'QUERY_VIEW_MAPPING',
  QUERY_VIEW_MAPPING_SOURCE_FIELD = 'QUERY_VIEW_MAPPING_SOURCE_FIELD',
  QUERY_VIEW_MAPPING_TARGET_FIELD = 'QUERY_VIEW_MAPPING_TARGET_FIELD',
  QUERY_MANDATORY_FILTERS = 'QUERY_MANDATORY_FILTERS',
  QUERY_OPTIONAL_FILTERS = 'QUERY_OPTIONAL_FILTERS',
  PAGES_INPUT_MAPPING = 'PAGES_INPUT_MAPPING',
  PAGES_INPUT_MAPPING_SOURCE_FIELD = 'PAGES_INPUT_MAPPING_SOURCE_FIELD',
  PAGES_INPUT_MAPPING_TARGET_FIELD = 'PAGES_INPUT_MAPPING_TARGET_FIELD',
  PAGES_OUTPUT_MAPPING = 'PAGES_OUTPUT_MAPPING',
  PAGES_OUTPUT_MAPPING_SOURCE_FIELD = 'PAGES_OUTPUT_MAPPING_SOURCE_FIELD',
  PAGES_OUTPUT_MAPPING_TARGET_FIELD = 'PAGES_OUTPUT_MAPPING_TARGET_FIELD',
  DEFAULT_FILTER = 'DEFAULT_FILTER',
  STANDARD_DATAGRID = 'STANDARD_DATAGRID',
  PARAMETER_MAPPING = 'PARAMETER_MAPPING',
  PARAMETER_MAPPING_SOURCE_FIELD = 'PARAMETER_MAPPING_SOURCE_FIELD',
  PARAMETER_MAPPING_TARGET_FIELD = 'PARAMETER_MAPPING_TARGET_FIELD',
  GRID_COLUMN_NAVIGATION_PAGE = 'GRID_COLUMN_NAVIGATION_PAGE',
  HOLD_VALUE_PARAMS_MAPPING = 'HOLD_VALUE_PARAMS_MAPPING',
  HOLD_VALUE_PARAMS_MAPPING_SOURCE_FIELD = 'HOLD_VALUE_PARAMS_MAPPING_SOURCE_FIELD',
  HOLD_VALUE_PARAMS_MAPPING_TARGET_FIELD = 'HOLD_VALUE_PARAMS_MAPPING_TARGET_FIELD',
  DETAIL_VIEW_PARAMS_MAPPING = 'DETAIL_VIEW_PARAMS_MAPPING',
  DETAIL_VIEW_PARAMS_MAPPING_SOURCE_FIELD = 'DETAIL_VIEW_PARAMS_MAPPING_SOURCE_FIELD',
  DETAIL_VIEW_PARAMS_MAPPING_TARGET_FIELD = 'DETAIL_VIEW_PARAMS_MAPPING_TARGET_FIELD',
  PARAMETER_MAPPING_QUERY_VIEW = 'PARAMETER_MAPPING_QUERY_VIEW',
  PARAMETER_MAPPING_QUERY_VIEW_SOURCE_FIELD = 'PARAMETER_MAPPING_QUERY_VIEW_SOURCE_FIELD',
  PARAMETER_MAPPING_QUERY_VIEW_TARGET_FIELD = 'PARAMETER_MAPPING_QUERY_VIEW_TARGET_FIELD',
  QUICK_FILTER_INPUT_MAPPING = 'QUICK_FILTER_INPUT_MAPPING',
  QUICK_FILTER_OUTPUT_MAPPING = 'QUICK_FILTER_OUTPUT_MAPPING',
  TBL_SEARCH_INPUT_MAPPING = 'TBL_SEARCH_INPUT_MAPPING',
  TBL_SEARCH_OUTPUT_MAPPING = 'TBL_SEARCH_OUTPUT_MAPPING',
  FORM_FIELD_INPUT_MAPPING = 'FORM_FIELD_INPUT_MAPPING',
  FORM_FIELD_OUTPUT_MAPPING = 'FORM_FIELD_OUTPUT_MAPPING',
  STANDARD_GRID_PARAMETER_MAPPING = 'STANDARD_GRID_PARAMETER_MAPPING',
  STANDARD_GRID_PARAMETER_MAPPING_SOURCE_FIELD = 'STANDARD_GRID_PARAMETER_MAPPING_SOURCE_FIELD',
  STANDARD_GRID_PARAMETER_MAPPING_TARGET_FIELD = 'STANDARD_GRID_PARAMETER_MAPPING_TARGET_FIELD',
  EMBEDDED_QUERY_VIEW_MAPPING = 'EMBEDDED_QUERY_VIEW_MAPPING',
  QUERY_PARAMETER_MAPPING = 'QUERY_PARAMETER_MAPPING',
  QUERY_DETAIL_PAGE_MAPPING = 'QUERY_DETAIL_PAGE_MAPPING',
  QUERY_DETAIL_VIEW_MAPPING = 'QUERY_DETAIL_VIEW_MAPPING',
  QUERY_HOLD_VIEW_VALUES = 'QUERY_HOLD_VIEW_VALUES',
  DETAIL_PAGE_PARAMETERS = 'DETAIL_PAGE_PARAMETERS',
  DETAIL_PAGE_PARAMETERS_SOURCE_FIELD = 'DETAIL_PAGE_PARAMETERS_SOURCE_FIELD',
  DETAIL_PAGE_PARAMETERS_TARGET_FIELD = 'DETAIL_PAGE_PARAMETERS_TARGET_FIELD',
  QUERY_VIEW_MAPPING_PAGE_VARIABLES = 'QUERY_VIEW_MAPPING_PAGE_VARIABLES',
  QUERY_VIEW_MAPPING_PAGE_VARIABLES_SOURCE_FIELD = 'QUERY_VIEW_MAPPING_PAGE_VARIABLES_SOURCE_FIELD',
  QUERY_VIEW_MAPPING_PAGE_VARIABLES_TARGET_FIELD = 'QUERY_VIEW_MAPPING_PAGE_VARIABLES_TARGET_FIELD',
  STANDARD_GRID_PARAMETER_MAPPING_PAGE_VARIABLES = 'STANDARD_GRID_PARAMETER_MAPPING_PAGE_VARIABLES',
  STANDARD_GRID_PARAMETER_MAPPING_PAGE_VARIABLES_SOURCE_FIELD = 'STANDARD_GRID_PARAMETER_MAPPING_PAGE_VARIABLES_SOURCE_FIELD',
  STANDARD_GRID_PARAMETER_MAPPING_PAGE_VARIABLES_TARGET_FIELD = 'STANDARD_GRID_PARAMETER_MAPPING_PAGE_VARIABLES_TARGET_FIELD',
  NAVIGATION_DATA_MAPPING = 'NAVIGATION_DATA_MAPPING',
  NAVIGATION_DATA_MAPPING_SOURCE_FIELD = 'NAVIGATION_DATA_MAPPING_SOURCE_FIELD',
  NAVIGATION_DATA_MAPPING_TARGET_FIELD = 'NAVIGATION_DATA_MAPPING_TARGET_FIELD',
  EXECUTE_ON_FIELD_MAPPING = 'EXECUTE_ON_FIELD_MAPPING',
  EXECUTE_ON_PAGE_VARIABLE_MAPPING = 'EXECUTE_ON_PAGE_VARIABLE_MAPPING',
  RULE_SOURCE_FIELD = 'RULE_SOURCE_FIELD',
  DEFAULT_FILTER_SOURCE_FIELD = 'DEFAULT_FILTER_SOURCE_FIELD',
  RULE_TARGET_FIELD = 'RULE_TARGET_FIELD',
  RULE_FIELD_VALUE = 'RULE_FIELD_VALUE',
  FOREIGN_KEY_PARENT_FIELDS = 'FOREIGN_KEY_PARENT_FIELDS'
}

export enum PublishTypes {
  PROTOTYPE = 'PROTOTYPE',
  PUSH = 'PUSH',
  PULL = 'PULL',
  PUSH_UI_LIBRARIES = 'PUSH_UI_LIBRARIES',
  PUSH_BE_LIBRARIES = 'PUSH_BE_LIBRARIES'
}

export enum ApplicationTypes {
  INDEPENDENT = 'INDEPENDENT',
  MEMBER = 'MEMBER',
  SUITE = 'SUITE'
}

export enum AppTypesUIDisplay {
  INDEPENDENT = 'Independent',
  MEMBER = 'Member',
  SUITE = 'Suite'
}

export enum IconType {
  CLASS_ICON = 'classIcon',
  SYSTEM_ICON = 'systemIcon',
  UPLOADED = 'uploaded'
}

export enum DefaultFields {
  CREATED_BY = 'Created By',
  CREATED_DATE = 'Created Date',
  MODIFIED_BY = 'Modified By',
  MODIFIED_DATE = 'Modified Date',
  LANGUAGE_CODE = 'Language Code'
}

// Global-level roles (user properties)
export enum GlobalRole {
  DEV_ADMIN = 'devAdmin',
  SYS_ADMIN = 'sysAdmin',
  DEV_VIEWER = 'devViewer'
}

// Organization-level roles (from user.orgInfos)
export enum OrgRole {
  ORG_ADMIN = 'Organization Admin',
  ARCHITECT = 'Architect',
  DEVELOPER = 'Developer',
  CONSULTANT = 'Consultant',
  VIEWER = 'Viewer',
  PROTOTYPE_VIEWER = 'Prototype Viewer'
}
